import { render } from "./card-dashboard.svg?vue&type=template&id=2f855efd?inline"
const script = {}
script.render = render

export default script